import React, { useState, useEffect } from "react";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Typography, Card, CardContent, Box } from "@mui/material";
import data_decks from "./../../../data/tarot/decks.json";
import { ENDPOINTS, getApiUrl } from "../../../common/endpoints";
import { Requests } from "../../../common/requests";
import { DECK_IMG_URL } from "../../../constants";
import SuitItem from "./SuitItem";
const TarotDecks = () => {
  const [decks, setDecks] = useState<any[]>(data_decks);
  const [expandedDeck, setExpandedDeck] = useState<any>(null);
  useEffect(() => {
    fetchDecks();
  }, []);

  const fetchDecks = async () => {
    const apiUrl = getApiUrl(ENDPOINTS.TAROT_LIST_DECKS);
    try {
      const data = await Requests.get(apiUrl);
      if (Array.isArray(data)) setDecks(data);
    } catch (e) {}
  };
  const columns: GridColDef[] = [
    { field: "title", headerName: "Deck Title", width: 200 },
    {
      field: "image",
      headerName: "Image",
      width: 150,
      renderCell: (params: GridRenderCellParams) => (
        <img
          src={DECK_IMG_URL.replace("DECK_ID", params.row.id)}
          alt={params.row.title}
          style={{ height: "60px" }}
        />
      ),
    },
  ];

  const handleRowClick = (row: any) => {
    setExpandedDeck((prev: any) => (prev?.id === row.id ? null : row));
  };

  return (
    <Box
      sx={{
        height: "100vh",
      }}
    >
      <Box
        sx={{
          padding: "10px",
        }}
      >
        <Typography
          color="primary"
          sx={{
            fontWeight: "bold",
            fontSize: "24px",
          }}
        >
          Tarot decks
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Box
          sx={{
            flex: 1,
            height: "calc(100vh - 60px)",
            overflowY: "auto",
          }}
        >
          <DataGrid
            rows={decks}
            columns={columns}
            onRowClick={(params) => handleRowClick(params.row)}
            autoHeight
            sx={{
              padding: "10px",
              border: "none!important",
              "& .MuiDataGrid-columnHeaders": {
                "& > div": {
                  "& > div": {
                    border: "none!important",
                  },
                },
              },
              "& .MuiDataGrid-columnHeader": {
                border: "none!important",
              },
              "& .MuiDataGrid-filler": {
                border: "none!important",
              },
              "& .MuiDataGrid-scrollbarFiller": {
                border: "none!important",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                color: "#2A4365",
                fontWeight: "bold",
              },
              "& .MuiDataGrid-row": {
                height: "80px!important",
                minHeight: "80px!important",
                backgroundColor: "#F7FAFC",
                margin: "4px 0",
                borderRadius: "10px",
                "&:hover": {
                  backgroundColor: "#2A4365!important",
                  "& .MuiDataGrid-cell": {
                    color: "#fff",
                  },
                },
                "&.Mui-selected": {
                  backgroundColor: "#2A4365!important",
                  "& .MuiDataGrid-cell": {
                    color: "#fff",
                  },
                },
              },
              "& .MuiDataGrid-cell": {
                padding: "10px",
                color: "#2A4365",
                height: "80px!important",
                minHeight: "80px!important",
                border: "none!important",
              },
              "& .MuiTablePagination-root": {
                color: "#2A4365",
              },
            }}
          />
        </Box>
        {expandedDeck && (
          <Box
            sx={{
              height: "calc(100vh - 60px)",
              overflowY: "auto",
            }}
          >
            <Card>
              <CardContent>
                <Typography variant="h6" color="primary">
                  {expandedDeck.title} - Suits and Cards
                </Typography>
                {expandedDeck.suits.map((suit: any) => (
                  <SuitItem key={suit.id} suit={suit} />
                ))}
              </CardContent>
            </Card>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TarotDecks;
